import { HttpStatusCode } from "axios";
import SavedSearchSchema from "marketplace/saved-searches/_schema/saved-search-schema";

/**
 * What to tell the user when a saved search request fails, by the status it failed with. A refusal
 * means the caller may not search the marketplace, unless the request named one saved search: then it
 * means the search is another user's.
 */
export function savedSearchFailureText(error: unknown, fallback: string, namedOneSearch = false): string {
  const status = typeof error === "object" && error !== null && "status" in error ? error.status : undefined;
  switch (status) {
    case HttpStatusCode.Conflict:
      return `You can keep up to ${SavedSearchSchema.MaximumPerUser} saved searches. Delete one to save another.`;
    case HttpStatusCode.Forbidden:
      return namedOneSearch
        ? "This saved search belongs to another user."
        : "You do not have permission to search the marketplace.";
    case HttpStatusCode.NotFound:
      return "That saved search no longer exists.";
    default:
      return fallback;
  }
}
